import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "time-span-editor" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = { class: "input-cell hours" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol" }, ":", -1)
const _hoisted_5 = { class: "input-cell minutes" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "symbol" }, ":", -1)
const _hoisted_7 = { class: "input-cell seconds" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "symbol" }, ":", -1)
const _hoisted_9 = { class: "input-cell seconds" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.h) = $event)),
          placeholder: "hh",
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.timeSpanChanged && _ctx.timeSpanChanged(...args)))
        }, null, 544), [
          [
            _vModelText,
            _ctx.h,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.m) = $event)),
          placeholder: "mm",
          onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.timeSpanChanged && _ctx.timeSpanChanged(...args)))
        }, null, 544), [
          [
            _vModelText,
            _ctx.m,
            void 0,
            { number: true }
          ]
        ])
      ]),
      (_ctx.showSeconds)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.s) = $event)),
                placeholder: "ss",
                onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.timeSpanChanged && _ctx.timeSpanChanged(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.s,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.showMilliseconds)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ms) = $event)),
                placeholder: "lll",
                onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.timeSpanChanged && _ctx.timeSpanChanged(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.ms,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}